module.exports = __webpack_public_path__ + "static/img/error.a2cd368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.jpg
// module id = jle9
// module chunks = 0